import { useParams } from 'react-router';

import { useIntranetModule } from '@/products/intranet/features/intranet/use-intranet-directory';
import { SiteDiaryPage } from '@/products/intranet/pages/site-diary-page';
import { WeeklyPlanPage } from '@/products/intranet/pages/weekly-plan-page';

/** `/intranet/modul/:instanceId` chooses the board from the instance kind. */
export function IntranetModulePage() {
  const { instanceId = '' } = useParams();
  const instance = useIntranetModule(instanceId);

  if (instance.isPending) {
    return <p className="text-sm text-muted-foreground">Modul wird geladen …</p>;
  }
  if (instance.data?.kind === 'weekly_plan') {
    return <WeeklyPlanPage />;
  }
  return <SiteDiaryPage />;
}
